import {Injectable, signal} from '@angular/core';
import {INotificationBadgesResponse} from '../../auth/models/i-notification-badges-response';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  readonly hasRecallsBadge = signal<boolean>(false);
  readonly hasBirthdaysBadge = signal<boolean>(false);

  setBadges(badges: INotificationBadgesResponse): void {
    this.hasRecallsBadge.set(badges.hasRecalls);
    this.hasBirthdaysBadge.set(badges.hasBirthdays);
  }

  setHasRecalls(hasRecalls: boolean): void {
    this.hasRecallsBadge.set(hasRecalls);
  }

  setHasBirthdays(hasBirthdays: boolean): void {
    this.hasBirthdaysBadge.set(hasBirthdays);
  }

  clearBadges(): void {
    this.hasRecallsBadge.set(false);
    this.hasBirthdaysBadge.set(false);
  }
}
